import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { IBaseErrorResponse } from '@common/base';
import { normalizeHttpValue, shakeParams } from '@common/params';
import { environment } from '../../../../src/environment/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  readonly #baseUrl = `${environment.API_URL}/v1`;
  readonly #http = inject(HttpClient);
  readonly #toastr = inject(ToastrService);

  public get<T>(url: string, params: any = {}): Observable<T> {
    params = shakeParams(params);
    return this.#http
      .get<T>(`${this.#baseUrl}${url}`, {
        params,
      })
      .pipe(
        catchError((error: IBaseErrorResponse) => {
          console.error('Error fetching data:', error);
          return throwError(() => error);
        })
      );
  }

  public post<T>(url: string, data: any, params: any = {}, headers: any = {}): Observable<T> {
    data = normalizeHttpValue(data);
    params = shakeParams(params);

    return this.#http
      .post<T>(`${this.#baseUrl}${url}`, data, {
        params,
        headers,
      })
      .pipe(
        catchError((error: any) => {
          console.error('Error posting data:', error);
          this.#toastr.error(error?.error?.message || error?.error?.detail || 'Что-то пошло не так');
          return throwError(() => error);
        })
      );
  }

  public patch<T>(url: string, data: any, params: any = {}, headers: any = {}): Observable<T> {
    data = normalizeHttpValue(data);
    params = shakeParams(params);

    return this.#http
      .patch<T>(`${this.#baseUrl}${url}`, data, {
        params,
        headers,
      })
      .pipe(
        catchError((error: any) => {
          console.error('Error patching data:', error);
          this.#toastr.error(error?.error?.message || error?.error?.detail || 'Что-то пошло не так');
          return throwError(() => error);
        })
      );
  }
}
